export const RequestStatus = {
  Draft: 'draft',
  In_Progress: 'in_progress',
  Under_Update: 'under_update',
  Completed: 'completed',
  Successful: 'successful',
  Rejected: 'rejected',
  Cancelled: 'cancelled'
};

export const RequestDict: any = {
  in_progress: 'Υπό Διεκπεραίωση',
  under_update: 'Επικαιροποίηση',
  successful: 'Ολοκληρωμένη',
  rejected: 'Απορριφθείσα',
  completed: 'Υποβληθέν',
  draft: 'Πρόχειρο',
};